import React from 'react';
import { MessageDescriptor, FormattedMessage } from 'react-intl';
import { Bone } from 'src/components/Placeholder/Placeholder';
import classNames from 'classnames';

export interface IButtonProps extends Omit<React.ComponentProps<'button'>, 'onClick'> {
    caption: MessageDescriptor | React.ReactText;
    onClick: () => void;
    dangerous?: boolean;
}

export const ButtonSkeleton: React.FC<{ caption?: MessageDescriptor, className?: string }> = ({ caption, className }) =>
    <Bone className={classNames('button', className)}>
        <FormattedMessage {...caption} />
    </Bone>